
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/invoices",
      function () {
        return require("private-next-pages/invoices/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/invoices"])
      });
    }
  